import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
    { label: 'Billing', to: '/' },
    { label: 'Domain', to: '/domain' },
    { label: 'Backups', to: '/backups' },
    { label: 'Support', to: '/support' },
];

const navStyle = {
    display: 'flex',
    flexWrap: 'wrap',
};

const navItemStyle = {
    flex: '1 1 0',
    minWidth: '96px',
    textAlign: 'center',
};

const isBillingRouteActive = (_, location) => {
    const pathname = location.pathname.toLowerCase();
    const topLevelRoutes = NAV_ITEMS.filter((item) => item.to !== '/').map((item) =>
        item.to.toLowerCase(),
    );

    return !topLevelRoutes.some((route) => {
        return pathname === route || pathname.startsWith(`${route}/`);
    });
};

/**
 * Renders the primary navigation when navigation is enabled.
 * @param {{showNav: boolean}} props
 * @returns {import('react').ReactElement|null}
 */
export default function HeaderNav({ showNav }) {
    if (!showNav) {
        return null;
    }

    return (
        <nav className="pro-nav" style={navStyle}>
            <NavLink
                className="pro-nav-item"
                to="/"
                activeClassName="active"
                isActive={isBillingRouteActive}
                style={navItemStyle}
            >
                Billing
            </NavLink>
            {NAV_ITEMS.filter((item) => item.to !== '/').map((item) => (
                <NavLink
                    key={item.to}
                    className="pro-nav-item"
                    to={item.to}
                    strict
                    activeClassName="active"
                    style={navItemStyle}
                >
                    {item.label}
                </NavLink>
            ))}
        </nav>
    );
}

HeaderNav.propTypes = {
    showNav: PropTypes.bool.isRequired,
};
